<template>
  <div class="project-wrapper">
    <div class="project-container">
      <div class="project-content">
        <p class="project-current-step">{{ Translator('soprasolar.project.confirmation.step', { number: id }) }}</p>
        <h1 class="project-title">{{ Translator('soprasolar.project.confirmation.title') }}</h1>
        <p class="project-description">{{ Translator('soprasolar.project.confirmation.description') }}</p>
      </div>
    </div>
    <div class="project-footer">
      <div class="project-actions">
        <a href="/" class="button-flat">
          {{ Translator('soprasolar.project.confirmation.button') }}
        </a>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
  @import "~@/soprasolar-project/assets/styles/import";
  .project-wrapper {
    @include vertical-spacing-inner-top;
  }
  .viewer-element {
    .project-container {
      @include vertical-spacing-inner-top;
      align-items: center;
      justify-content: center;
    }
    .project-content {
      max-width: rem(500);
      text-align: center;
    }
  }
</style>
<script>
import AppControlService from '@/soprasolar-project/services/AppControl';

export default {
  name: 'confirmation',
  components: {},
  data () {
    return {
      id: AppControlService.id,
      datas: AppControlService.datas
    }
  },

  created() {
    AppControlService.on('datas', this._onUpdateDatas);
  },

  beforeDestroy() {
    AppControlService.off('datas', this._onUpdateDatas);
  },

  mounted() {},

  methods: {
    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },

    _onUpdateDatas(datas) {
      this.datas = datas;
    }
  }
};
</script>